/**
 * Notifications open the exact place they are about (Aziz 2026-09-29): a mention opens the
 * chat, an overdue step or a decision opens the Work card, a review comment opens that
 * video at that moment with the comment highlighted. The server writes these links for new
 * notifications (api/app/notify.py smart_link); this mirrors the same table so the ones
 * already in people's lists behave the same.
 */
import type { Notification } from '@/lib/queries';

export const SECTION_BY_KIND: Record<string, string> = {
  chat_mention: 'chat', client_message: 'chat',
  sla_overdue: 'work', sla_reminder: 'work', review_requested: 'work', phase_submitted: 'work',
  task_approved: 'work', task_cancelled: 'work', task_handed_back: 'work', task_revision: 'work',
  task_assigned: 'work', task_reopened: 'work', job_assigned: 'work', revision_requested: 'work',
  creative_deferred: 'work', approval_decided: 'work', dual_approved: 'work', final_approved: 'work',
  marked_shot: 'shoot', shoot_scheduled: 'shoot', script_approved: 'shoot', script_sent: 'shoot',
  script_changes: 'shoot', script_for_you: 'shoot',
  raws_approved: 'assets', asset_uploaded: 'assets',
};

export function smartLink(n: Pick<Notification, 'kind' | 'link' | 'related_creative_id'>): string | null {
  const link = n.link ?? null;
  const cid = n.related_creative_id;
  // "a task is yours" pointed at the whole My Tasks list: open that creative's Work card
  if ((link === '/tasks' || !link) && cid && SECTION_BY_KIND[n.kind] === 'work') return `/creatives/${cid}#work`;
  if (!link) return null;
  const m = link.match(/^\/creatives\/[^/?#]+$/);
  if (m && SECTION_BY_KIND[n.kind]) return `${link}#${SECTION_BY_KIND[n.kind]}`;
  return link;
}

/** The creative page's sections and the fold key each one remembers. */
export const SECTION_FOLD: Record<string, string> = {
  chat: 'creative.chat.open', work: 'creative.work.open', assets: 'creative.assets.open',
  shoot: 'creative.shoot.open', routing: 'creative.routing.open',
};
